import './App.css';
import Header from './header/header';
import Hero from './hero/hero';
import Features from './features/features';
import Nft from './nft-collection/Nft';
import Bst from './buy-sell-trade/Bst';
import Faq from './faq/Faq';
import Footer from './footer/Footer';
function App() {
  return (
    <div className="App">
      <div className="main">
        <Header />
        <Hero />
        <Features />
        <Nft />
        <Bst />
        <Faq />
        <Footer />
      </div>
    </div>
  );
}

export default App;
